// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/special-surface-takeoffs.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/special-surface-takeoffs/special-surface-takeoffs.js';

mount([g0]);
